<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" dark v-on="on" style="display: none"
        >Open Dialog</v-btn
      >
    </template>
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span class="headline">Zmena hesla</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Pôvodné heslo*"
                  type="password"
                  v-model="oldP"
                  :rules="requiredRule"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Nové heslo*"
                  type="password"
                  :rules="pwdRules"
                  v-model="newP1"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Zopakovať nové heslo*"
                  type="password"
                  :rules="pwd2Rules"
                  v-model="newP2"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>*indikuje povinné polia</small>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Zavrieť</v-btn
          >
          <v-btn color="blue darken-1" text @click="savePassword()"
            >Uložiť</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogChangePassword",

  data: () => ({
    dialog: false,
    oldP: "",
    newP1: "",
    newP2: "",

    valid: true,
    requiredRule: [v => !!v || "Položka je povinná"],
    pwdRules: [v => v.length >= 6 || "Heslo musí mať najmenej 6 znakov"]
  }),

  computed: {
    pwd2Rules() {
      const rules = []
      const rule = v => (!!v && v) === this.newP1 || "Heslá nie sú rovnaké"
      rules.push(rule)
      return rules
    }
  },

  methods: {
    show: function() {
      this.dialog = true
      this.$refs.form.reset()
    },

    async savePassword() {
      if (this.$refs.form.validate()) {
        try {
          let response = await this.$axios.post("/r/password", {
            old: this.oldP,
            new: this.newP1
          })
          if (response.status === 200) {
            this.$store.commit("message", "Zmena hesla bola úspešná")
            this.dialog = false
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        } catch (error) {
          this.$store.commit("alert", error.toString())
        }
      } else {
        this.$store.commit("alert", "Vo formulári sú chyby")
      }
    }
  }
}
</script>
